import { get } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getBookingSchedule({ commit }, { id, params } = {}) {
    return get(`/booking/schedule/resource/${id}`, params).then(response => {
      commit('setBookingSchedule', response.data.data);

      return response;
    });
  },

  setFilter({ commit }, filter) {
    commit('setBookingScheduleFilter', cloneDeep(filter));
  },

  getFilteredBuildingComplexes(_, params) {
    return get(`/booking/filters/building-complexes`, params);
  },
  getFilteredBuildings(_, params) {
    return get(`/booking/filters/buildings`, params);
  },
  getFilteredResources(_, params) {
    return get(`/booking/filters/resources`, params);
  }
};
